var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"arrow-animation flex justify-center cursor-pointer"},[_c('i',{staticClass:"fas fa-chevron-down"}),_c('i',{staticClass:"fas fa-chevron-down"})])
}]

export { render, staticRenderFns }